import React, { useState, useEffect } from "react";
import useSessionStorage from "./useSessionStorage";
import useAxios from "./useAxios";
import "./FormStyles.css";

const UserProfile = () => {
  const [token] = useSessionStorage("token", null);
  const [userInfo, setUserInfo] = useState(null);
  const [axios] = useAxios(true);

  useEffect(() => {
    if (token) {
      // Decode JWT token to get user info
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const userId = payload.sub || payload.nameid || payload.unique_name; // Check multiple possible claim names for user ID
        
        if (userId) {
          axios.get(`user/${userId}`, (data) => {
            setUserInfo(data);
          }, (error) => {
            console.error("Error fetching user data:", error);
            // If API call fails, fall back to token data
            setUserInfo({
              name: payload.name || payload.unique_name,
              email: payload.email,
              username: payload.unique_name || payload.name,
              userType: payload.user_type || 'user',
              profilePictureUrl: null // Will be null for fallback data
            });
          });
        } else {
          // If no userId in token, use token data directly
          setUserInfo({
            name: payload.name || payload.unique_name,
            email: payload.email,
            username: payload.unique_name || payload.name,
            userType: payload.user_type || 'user',
            profilePictureUrl: null // Will be null for fallback data
          });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!userInfo) {
    return <h1>Loading...</h1>;
  }

  return (
    <div className="form-container" style={{ maxWidth: '600px', margin: '60px auto 0 auto', padding: '20px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>User Profile</h2>
      
      {userInfo.profilePictureUrl && (
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img 
            src={userInfo.profilePictureUrl} 
            alt="Profile Picture"
            style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '3px solid #007bff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
      
      <div className="profile-section" style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '20px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <div className="profile-field" style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
            Name:
          </label>
          <div style={{ fontSize: '16px', color: '#495057' }}>
            {userInfo.name || userInfo.username || 'Not provided'}
          </div>
        </div>

        <div className="profile-field" style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
            Email:
          </label>
          <div style={{ fontSize: '16px', color: '#495057' }}>
            {userInfo.email || 'Not provided'}
          </div>
        </div>

        <div className="profile-field" style={{ marginBottom: '15px' }}>
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
            Username:
          </label>
          <div style={{ fontSize: '16px', color: '#495057' }}>
            {userInfo.username || 'Not provided'}
          </div>
        </div>

        <div className="profile-field">
          <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
            User Type:
          </label>
          <div style={{ fontSize: '16px', color: '#495057' }}>
            <span style={{
              padding: '4px 8px',
              borderRadius: '4px',
              backgroundColor: userInfo.userType === 'admin' ? '#28a745' : '#007bff',
              color: 'white',
              fontSize: '14px',
              textTransform: 'capitalize'
            }}>
              {userInfo.userType || 'User'}
            </span>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', color: '#6c757d', fontSize: '14px' }}>
        <p>To update your profile information, please contact your administrator.</p>
      </div>
    </div>
  );
};

export default UserProfile;